import { Label } from "@d12labs/ui/label";
import { PageBody, PageHeader } from "@d12labs/ui/page-header";
import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

/**
 * Standard form page layout: PageHeader with title + subtitle + optional actions,
 * then a PageBody with a centered max-w-2xl content area. Renders a fragment so
 * it slots directly into the flush-flex <main>.
 */
export function FormShell({
	icon,
	title,
	subtitle,
	actions,
	children,
}: {
	icon?: LucideIcon;
	title: string;
	subtitle?: string;
	actions?: ReactNode;
	children: ReactNode;
}) {
	return (
		<>
			<PageHeader icon={icon} title={title} subtitle={subtitle} actions={actions} />
			<PageBody className="px-6 py-8">
				<div className="mx-auto w-full max-w-2xl space-y-5">{children}</div>
			</PageBody>
		</>
	);
}

/**
 * A `datetime-local` picker for when an activity happened. Empty = now. Exposing
 * it lets the user backfill past-dated sessions — which the streak engine
 * recomputes correctly from full history.
 */
export function WhenField({ value, onChange }: { value: string; onChange: (v: string) => void }) {
	return (
		<div className="flex flex-col gap-1.5">
			<Label htmlFor="when">When (optional — defaults to now)</Label>
			<input
				id="when"
				type="datetime-local"
				value={value}
				onChange={(e) => onChange(e.target.value)}
				className="h-9 rounded-md border border-input bg-transparent px-3 text-sm shadow-xs outline-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50"
			/>
		</div>
	);
}
